// Options for the sections where the popup can be shown
export const popUpShowingSectionOptions = [
  { value: 0, title: "الصفحة الرئيسية" },
  { value: 1, title: "المشاريع" },
  { value: 2, title: "الاهداءات" },
  { value: 3, title: "المنتجات" },
  { value: 4, title: "تسجيل الدخول" },
  { value: 5, title: "البطاقة" },
];
